import { WebsocketMessage } from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const messageReceived = createAction(
  '[Core/Notification] On Message Received',
  props<{ message: WebsocketMessage }>(),
);
